import { render, staticRenderFns } from "./PartialBlockVideo.vue?vue&type=template&id=bb14e4cc&scoped=true&"
import script from "./PartialBlockVideo.vue?vue&type=script&lang=js&"
export * from "./PartialBlockVideo.vue?vue&type=script&lang=js&"
import style0 from "./PartialBlockVideo.vue?vue&type=style&index=0&id=bb14e4cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb14e4cc",
  null
  
)

export default component.exports